









































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Place } from '@/Dto';
import Tags from '../Tags.vue';
import StarRating from 'vue-star-rating';
import { Util } from '@/Util';

@Component({
  name: 'panel-place-detail',
  components: {
      Tags, StarRating,
  }
})
export default class PanelPlaceDetail extends Vue {
  @Prop()
  private place!:Place;

  link(place:Place) {
    return Util.getPlaceLink(place);
  }

  trim(openingHours:string) {
    return openingHours.replace(new RegExp(' ', 'g'), '');
  }

  address(place: Place) {
    return place.address.number + ' ' + place.address.street + ', ' + place.address.suburb;
  }
}
